import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackBannerClick, trackBannerShow } from './tracking';
import { configSelector } from '../../../selectors/configSelector';
import { selectLocationId } from '../../../selectors/selectLocationId';
import { RentRaffle2024Banner } from '../../components/RentRaffle2024Banner';

const NOVOSIBIRSK_CITY_ID = 4897;

export const RENT_RAFFLE_2024_REGIONS = [1, NOVOSIBIRSK_CITY_ID, 4593];

/**
 * Контейнер баннера розыгрыша 2024.
 */
export const RentRaffle2024BannerContainer = () => {
  const config = useSelector(configSelector);
  const locationId = useSelector(selectLocationId);

  const url =
    config.get<string>(
      locationId === NOVOSIBIRSK_CITY_ID
        ? 'audience-activation.rentRaffle2024Banner.Novosibirsk.url'
        : 'audience-activation.rentRaffle2024Banner.url',
    ) || '';

  return (
    <ActionAfterViewObserver callback={trackBannerShow} percentVisible={0.8} triggerOnce>
      <RentRaffle2024Banner url={url} onClick={trackBannerClick} />
    </ActionAfterViewObserver>
  );
};
